import React, { Component } from "react";
import RestContextHOC from '../../Contexts/RestContextHOC'
import UserContextHOC from "../../Contexts/UserContextHOC";
import CartContextHOC from "../../Contexts/CartContextHOC";
import AnalyticsContextHOC from '../../Contexts/AnalyticsContextHOC'
import { injectStripe, Elements } from 'react-stripe-elements';
import classnames from "classnames"


class CreditCardSaved extends Component {
  constructor(props){
    super(props);
    this.handleCardDelete = this.handleCardDelete.bind(this);
  }

  handleCardDelete(e, card){
    this.props.deleteSavedCard(card)
  }

  render() {
    return (
      <div style={{
        display:'flex', 
        flexDirection:'row', 
        alignItems:'center', 
        justifyContent:'space-between'
      }}>
        <div 
          className={classnames(
            {'saved-card-container':!this.props.chooseCardEditOpen},
            {'saved-card-container-selected':this.props.cart.savedCard 
              && this.props.cart.savedCard.id === this.props.card.id 
              && !this.props.chooseCardEditOpen},
            {'saved-card-container-edit': this.props.chooseCardEditOpen}
          )}
          onClick={()=>{
            if(!this.props.chooseCardEditOpen){
              this.props.cart.selectPaymentNew("card", this.props.card, this.props.card)
            }
          }} 
          key={this.props.card.id}
        >
          <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
            {!this.props.chooseCardEditOpen && (
              <>
                {this.props.cart.savedCard 
                    && this.props.cart.savedCard.id === this.props.card.id ? (
                  <svg height="24" width="24">
                    <circle cx="12" cy="12" r="10" stroke="#b7b7b7" 
                      fill={this.props.rest.hex_color_primary} strokeWidth="3" 
                    />
                  </svg>
                ) : (
                  <CircleUnfilled/> 
                ) }
              </>
            )}

            <CreditCard style={{marginLeft:'13px', marginRight:'9px'}} />
            <div>{this.props.card.brand}</div>
          </div>
          <div>
            <div>•••• {this.props.card.last4}</div>
          </div>
       </div>

      {this.props.chooseCardEditOpen && (
        <div 
          className='delete-card-container'
          onClick={(e)=>this.handleCardDelete(e, this.props.card)} 
        >
          <TrashCan/> 
        </div>
      )}          
     </div>
    )
  }
}

const CircleUnfilled = props => (
  <svg height="24" width="24" {...props} >
    <circle {...props} cx="12" cy="12" r="10" stroke="#b7b7b7" strokeWidth="3" fill="white" />
  </svg>
)

const CreditCard = props => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} width="32" height="32" viewBox="0 0 24 24"><path d="M22 4h-20c-1.104 0-2 .896-2 2v12c0 1.104.896 2 2 2h20c1.104 0 2-.896 2-2v-12c0-1.104-.896-2-2-2zm0 13.5c0 .276-.224.5-.5.5h-19c-.276 0-.5-.224-.5-.5v-6.5h20v6.5zm0-9.5h-20v-1.5c0-.276.224-.5.5-.5h19c.276 0 .5.224.5.5v1.5zm-9 6h-9v-1h9v1zm-3 2h-6v-1h6v1zm10-2h-3v-1h3v1z"/></svg>
)

const TrashCan = props => (
<svg {...props} width="23" height="26" viewBox="0 0 23 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.7589 21.125H14.9911C15.1545 21.125 15.3112 21.0608 15.4267 20.9465C15.5422 20.8322 15.6071 20.6772 15.6071 20.5156V9.54687C15.6071 9.38526 15.5422 9.23026 15.4267 9.11598C15.3112 9.0017 15.1545 8.9375 14.9911 8.9375H13.7589C13.5955 8.9375 13.4388 9.0017 13.3233 9.11598C13.2078 9.23026 13.1429 9.38526 13.1429 9.54687V20.5156C13.1429 20.6772 13.2078 20.8322 13.3233 20.9465C13.4388 21.0608 13.5955 21.125 13.7589 21.125ZM22.1786 4.0625H17.9477L16.2022 1.1832C15.9831 0.822156 15.6732 0.523398 15.3027 0.316041C14.9322 0.108683 14.5137 -0.00020025 14.088 2.76476e-07H8.91199C8.48646 -2.48203e-05 8.06817 0.108942 7.69786 0.316291C7.32755 0.52364 7.01783 0.822304 6.79886 1.1832L5.0523 4.0625H0.821429C0.603572 4.0625 0.394639 4.1481 0.240591 4.30048C0.0865431 4.45285 0 4.65951 0 4.875L0 5.6875C0 5.90299 0.0865431 6.10965 0.240591 6.26202C0.394639 6.4144 0.603572 6.5 0.821429 6.5H1.64286V23.5625C1.64286 24.209 1.90249 24.8289 2.36463 25.2861C2.82677 25.7432 3.45357 26 4.10714 26H18.8929C19.5464 26 20.1732 25.7432 20.6354 25.2861C21.0975 24.8289 21.3571 24.209 21.3571 23.5625V6.5H22.1786C22.3964 6.5 22.6054 6.4144 22.7594 6.26202C22.9135 6.10965 23 5.90299 23 5.6875V4.875C23 4.65951 22.9135 4.45285 22.7594 4.30048C22.6054 4.1481 22.3964 4.0625 22.1786 4.0625ZM8.82214 2.58527C8.8496 2.54007 8.88844 2.50269 8.93487 2.47679C8.98131 2.45089 9.03374 2.43735 9.08705 2.4375H13.9129C13.9662 2.43744 14.0185 2.45102 14.0648 2.47692C14.1112 2.50282 14.1499 2.54015 14.1773 2.58527L15.0737 4.0625H7.92627L8.82214 2.58527ZM18.8929 23.5625H4.10714V6.5H18.8929V23.5625ZM8.00893 21.125H9.24107C9.40446 21.125 9.56116 21.0608 9.6767 20.9465C9.79224 20.8322 9.85714 20.6772 9.85714 20.5156V9.54687C9.85714 9.38526 9.79224 9.23026 9.6767 9.11598C9.56116 9.0017 9.40446 8.9375 9.24107 8.9375H8.00893C7.84554 8.9375 7.68884 9.0017 7.5733 9.11598C7.45777 9.23026 7.39286 9.38526 7.39286 9.54687V20.5156C7.39286 20.6772 7.45777 20.8322 7.5733 20.9465C7.68884 21.0608 7.84554 21.125 8.00893 21.125Z" fill="#EC0101"/>
</svg>
)


export default injectStripe(RestContextHOC(
  AnalyticsContextHOC(CartContextHOC(UserContextHOC(CreditCardSaved)))))
